import { render, staticRenderFns } from "./OffenseTypes.vue?vue&type=template&id=87690938"
import script from "./OffenseTypes.vue?vue&type=script&lang=js"
export * from "./OffenseTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports